import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCalendarCheck } from 'react-icons/fa';

const FloatingBookButton = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Desktop Button */}
      <a
        href="https://fareharbor.com/embeds/book/nautitours_pt/?full-items=yes&flow=1580578"
        className="hidden md:flex fixed bottom-8 right-8 z-50 bg-blue-600 hover:bg-blue-700 text-white px-6 py-4 rounded-full shadow-2xl items-center space-x-3 transition-all duration-300 transform hover:scale-110"
        data-testid="floating-book-button"
      >
        <FaCalendarCheck className="text-2xl" />
        <span className="font-bold text-lg">{t('hero.bookNow')}</span>
      </a>

      {/* Mobile Button */}
      <a
        href="https://fareharbor.com/embeds/book/nautitours_pt/?full-items=yes&flow=1580578"
        className="md:hidden fixed bottom-4 right-4 z-50 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 transform hover:scale-110"
        data-testid="floating-book-button-mobile"
      >
        <FaCalendarCheck className="text-2xl" />
      </a>
    </>
  );
};

export default FloatingBookButton;
